import { useRouter } from "next/router";
import React, { useState } from "react";
import { Container, Accordion, Row, Col } from "react-bootstrap";

const Faqs = ({ faqsData }) => {
  const { locale } = useRouter();
  const [activeKey, setActiveKey] = useState(null);
  const dir = locale === "en" ? "ltr" : "rtl";
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  return (
    <div className="faqs faqs-page">
      <Container>
        <Accordion activeKey={activeKey} className="faq">
          <Row>
            {faqsData?.map((faq, index) => (
              <Col lg={6} key={index}>
                <Accordion.Item eventKey={index.toString()}>
                  <Accordion.Header
                    as="div"
                    onClick={() => handleToggle(index.toString())}
                  >
                    {faq?.question?.[locale]}
                  </Accordion.Header>
                  <Accordion.Body>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: faq?.answer?.[locale],
                      }}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              </Col>
            ))}
          </Row>
        </Accordion>
      </Container>
    </div>
  );
};

export default Faqs;
